module.exports = __webpack_public_path__ + "img/vegetable-winter-squash-190x100.129bb6de.jpg";